if (!customElements.get('pop-cart-discount')) {
  customElements.define('pop-cart-discount', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.button = this.querySelector('button[type="submit"]');
      this.message = this.querySelector('[data-message]');
      this.remove = this.querySelector('[data-remove]');
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        const code = this.input.value.trim();
        if (code) this.update(code);
      });
      this.remove.addEventListener('click', () => this.update(''));
      this.loadCodes();
    }
    async loadCodes() {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await response.json();
        this.codes = (cart.discount_codes || []).filter((code) => code.applicable).map((code) => code.code);
        if (this.codes.length) {
          this.input.value = this.codes.join(', ');
          this.message.textContent = this.dataset.applied + ' ' + this.codes.join(', ');
          this.remove.hidden = false;
        }
      } catch (_) { /* The form remains available when the initial request fails. */ }
    }
    async update(code) {
      this.button.disabled = true;
      this.remove.disabled = true;
      this.message.textContent = this.dataset.loading;
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code })
        });
        const cart = await response.json();
        if (!response.ok || cart.status) throw new Error();
        if (code) {
          const requested = code.split(',').map((item) => item.trim().toLowerCase());
          const accepted = (cart.discount_codes || []).filter((item) => item.applicable).map((item) => item.code.toLowerCase());
          const allocations = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap((item) => (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application))];
          const applied = allocations.filter((item) => item.type === 'discount_code').map((item) => item.title.toLowerCase());
          if (!requested.some((item) => accepted.includes(item) || applied.includes(item))) {
            this.message.textContent = this.dataset.invalid;
            return;
          }
        }
        window.location.reload();
      } catch (_) {
        this.message.textContent = this.dataset.error;
      } finally {
        this.button.disabled = false;
        this.remove.disabled = false;
      }
    }
  });
}
